import s from './SliderBlock.module.scss';
import {TSliderBlockProps} from "@/app/[locale]/common/components/SliderBlock/types";
import {ARRAY_LENGTH} from "../../constants/app";
import {Label} from "@/app/[locale]/common/components/Label/Label";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {SliderButtonsGroup} from "@/app/[locale]/common/components/SliderButtonsGroup/SliderButtonsGroup";
import {IndustriesSlider} from "@/app/[locale]/common/components/Industries/IndustriesSlider/IndustriesSlider";

export const SliderBlock = ({ label, slidesPerView, navigationId, marginBottom = 'marginBottom140', data, card }: TSliderBlockProps) => {
    const length = data.length;
    return (
        <div className={`${s.sliderBlock} ${s[marginBottom]}`}>
            <div className={`${s.sliderBlock_labelContainer} ${length === ARRAY_LENGTH.TWO ? s.sliderBlock_labelContainerTwoItems : ''}`}>
                <Label>{ label }</Label>
                <Line className={s.sliderBlock_line}/>
                <div
                    className={`${s.sliderBlock_buttonsContainer} ${length === ARRAY_LENGTH.TWO ? s.sliderBlock_buttonsContainerTwoItems : ''} ${length > 3 ? s.sliderBlock_buttonsContainerMoreThanTreeItems : ''}`}>
                    <SliderButtonsGroup navigationId={navigationId}/>
                </div>
            </div>

            <IndustriesSlider
                slidesPerView={slidesPerView}
                data={data}
                navigationId={navigationId}
                renderSlide={(item, index) => card(item, index)}
            />
        </div>
    );
};